var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSdn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FAE922;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000176744206542114938880000008912049994598369183_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000020387398189958861110000007639357108602584246_);}\n\t.st4{fill:url(#SVGID_00000114794864139563725760000000548426051530963336_);}\n\t.st5{fill:url(#SVGID_00000087384026713803244720000007957027910160125850_);}\n\t.st6{fill:url(#SVGID_00000170264658647278015060000012225824507850513580_);}\n\t.st7{fill:url(#SVGID_00000110463534537728083930000002325866508875829927_);}\n\t.st8{fill:url(#SVGID_00000103953462170522840300000007895088258641391544_);}\n\t.st9{fill:url(#SVGID_00000159470655222299211520000010328160202413024647_);}\n\t.st10{fill:url(#SVGID_00000080889678510543686480000016853897392684481947_);}\n\t.st11{fill:url(#SVGID_00000118372240605929450870000010897368027802912951_);}\n\t.st12{fill:url(#SVGID_00000152951917683934722690000005754227733160480683_);}\n\t.st13{fill:url(#SVGID_00000167375270698234064110000014415273418894199174_);}\n\t.st14{fill:url(#SVGID_00000167362043962393816640000007681294005920143764_);}\n\t.st15{fill:url(#SVGID_00000000220781380475210650000004726955009143148183_);}\n\t.st16{fill:url(#SVGID_00000076579677492727910990000004436505859597071007_);}\n\t.st17{fill:url(#SVGID_00000152969016614954070670000012829778522983081088_);}\n\t.st18{fill:url(#SVGID_00000080897937040735453580000006869462091327207350_);}\n\t.st19{fill:url(#SVGID_00000025409764080563268440000003041554243145583797_);}\n\t.st20{fill:url(#SVGID_00000114775549925591434570000014948555310528774022_);}\n\t.st21{fill:url(#SVGID_00000181797787567687070340000005881916559532203412_);}\n\t.st22{fill:url(#SVGID_00000147904498831008305150000015901333021251828910_);}\n\t.st23{fill:url(#SVGID_00000064314041126371650570000012758090330305626269_);}\n\t.st24{fill:url(#SVGID_00000178177776731420858170000012836595004906129071_);}\n\t.st25{fill:url(#SVGID_00000021108414042886509130000015210113833178317960_);}\n\t.st26{fill:url(#SVGID_00000146471406243169555850000002735593692164579985_);}\n\t.st27{fill:url(#SVGID_00000137827583199589549370000001228272986403820690_);}\n\t.st28{fill:url(#SVGID_00000139262423087351492410000007503474699357396905_);}\n\t.st29{fill:url(#SVGID_00000114795742794095670150000017261625763743048075_);}\n\t.st30{fill:url(#SVGID_00000133500015346680564720000011995067378548315816_);}\n\t.st31{fill:url(#SVGID_00000072988462879544471700000011432154453455414200_);}\n\t.st32{fill:url(#SVGID_00000025424554549623864850000000232838377450872711_);}\n\t.st33{fill:url(#SVGID_00000120557374853875507060000005270337351825060259_);}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000080182211408782444830000016916015764656148124_);}\n\t.st35{fill:#FFFFFF;}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000033341851087538362050000018171009986118372227_);}\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000154400131065201193950000002982952791743223486_);}\n\t.st38{fill:#FAE922;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.74,664.1c22.71-24.16,38.52-54.89,44.28-89.02c0.79-5.51,4.75-40.85-14.86-88.24 c-2.58-6.24-5.97-13.02-14.55-11.11c-7.94,1.76-104.8,38.66-110.68,42.48c-5.88,3.82-7.94,11.46-7.94,29.4 c0,17.93,2.35,68.79,1.17,92.3c-0.57,11.48-1.95,22.47-2.39,31.3c-0.97,19.38,1.6,20.8,19.89,21.13 C308.12,692.7,343.8,687.81,372.74,664.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 243.2716,
    cy: 444.1898,
    r: 376.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3273,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7697,
    style: {
      stopColor: "#6D6D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9091,
    style: {
      stopColor: "#6D6D6C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.19,384.75c90.84,0,164.47,73.63,164.47,164.46c0,64.48-37.11,120.28-91.14,147.24H173.87 c-54.03-26.96-91.14-82.76-91.14-147.24C82.72,458.39,156.36,384.75,247.19,384.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077290983692825392370000018210950268059216307_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.1912,
    y1: 307.2632,
    x2: 247.1912,
    y2: 495.6719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000077290983692825392370000018210950268059216307_)"
    },
    d: " M247.19,518.03c49.49,0,89.85-27.46,89.85-61.13c0-33.67-40.36-61.12-89.85-61.12c-49.48,0-89.85,27.46-89.85,61.12 C157.34,490.56,197.7,518.03,247.19,518.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163757779201651733620000014134310977690874549_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.9842,
    y1: 655.5682,
    x2: 226.7628,
    y2: 655.5682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#946F29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#433717"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000163757779201651733620000014134310977690874549_)"
    },
    d: " M226.59,671.19c0.09,1.86,0.16,3.55,0.17,5.1c-4.12,4.08-8.47,4.84-15.5,5.14c-27.56,1.14-53.98-4.37-74.77-21.24 c-9.37-7.6-16.93-18.02-24.51-30.63C120.6,642.87,153.81,684.35,226.59,671.19z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109012844488453116980000009641293380263539374_",
    cx: 245.0076,
    cy: 610.6086,
    r: 161.2916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109012844488453116980000009641293380263539374_)"
    },
    d: "M82.3,596.11 c-0.58-1.95-1.14-3.9-1.66-5.87C81.15,592.21,81.71,594.17,82.3,596.11z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163067444197191499800000003272787357913685680_",
    cx: 244.9941,
    cy: 610.6055,
    r: 161.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163067444197191499800000003272787357913685680_)"
    },
    d: "M80.63,590.25 c-0.52-1.97-1.01-3.96-1.46-5.95C79.63,586.29,80.11,588.27,80.63,590.25z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059988959590194828690000012330242962620939427_",
    cx: 245.0038,
    cy: 610.6084,
    r: 161.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059988959590194828690000012330242962620939427_)"
    },
    d: "M97.68,631.75 c-1.22-2.13-2.4-4.29-3.54-6.48C95.28,627.46,96.46,629.62,97.68,631.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000115514559423811685460000005698402175388960687_",
    cx: 247.6943,
    cy: 614.361,
    r: 195.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115514559423811685460000005698402175388960687_)"
    },
    d: "M394.4,635.61 c0.85-1.39,1.68-2.8,2.49-4.22C396.08,632.81,395.24,634.21,394.4,635.61z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000048502571360887968240000016012273763204375430_",
    cx: 247.6659,
    cy: 614.3597,
    r: 195.2467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048502571360887968240000016012273763204375430_)"
    },
    d: "M393.29,637.43 c0.38-0.6,0.73-1.21,1.1-1.82C394.03,636.21,393.67,636.83,393.29,637.43z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000161592809619666741420000003472060881241695665_",
    cx: 247.6807,
    cy: 614.3613,
    r: 195.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161592809619666741420000003472060881241695665_)"
    },
    d: "M398.24,628.98 c0.71-1.29,1.4-2.59,2.08-3.91C399.64,626.39,398.95,627.69,398.24,628.98z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150065707341703557720000017493965756339542162_",
    cx: 247.6693,
    cy: 614.3622,
    r: 195.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150065707341703557720000017493965756339542162_)"
    },
    d: "M396.89,631.39 c0.46-0.8,0.9-1.6,1.35-2.41C397.79,629.79,397.35,630.59,396.89,631.39z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000151537829918760043190000001714543885622921380_",
    cx: 247.6939,
    cy: 614.3608,
    r: 195.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151537829918760043190000001714543885622921380_)"
    },
    d: "M400.31,625.07 c0.42-0.82,0.85-1.63,1.26-2.46C401.16,623.44,400.74,624.26,400.31,625.07z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090265661018099292690000012953503736434138258_",
    cx: 247.686,
    cy: 614.3614,
    r: 195.2192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090265661018099292690000012953503736434138258_)"
    },
    d: "M389.55,643.16 c1.29-1.88,2.54-3.79,3.75-5.73C392.08,639.37,390.83,641.28,389.55,643.16z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132786138022597613570000009313333769831994557_",
    cx: 247.6849,
    cy: 614.3614,
    r: 195.2211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132786138022597613570000009313333769831994557_)"
    },
    d: "M401.57,622.62 c0.8-1.61,1.57-3.24,2.32-4.88C403.14,619.38,402.37,621.01,401.57,622.62z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000191162228077502140000010460861616976582325_",
    cx: 247.6915,
    cy: 614.3611,
    r: 195.2126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000191162228077502140000010460861616976582325_)"
    },
    d: "M380.9,654.72 c1.03-1.26,2.04-2.54,3.03-3.83C382.94,652.19,381.93,653.46,380.9,654.72z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000027570210083956610280000004629486378262086319_",
    cx: 247.665,
    cy: 614.3575,
    r: 195.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027570210083956610280000004629486378262086319_)"
    },
    d: "M379.49,656.46 c0.48-0.57,0.94-1.16,1.41-1.73C380.43,655.3,379.96,655.88,379.49,656.46z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114060634651473744280000011458356074777678990_",
    cx: 247.6638,
    cy: 614.359,
    r: 195.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114060634651473744280000011458356074777678990_)"
    },
    d: "M388.4,644.79 c0.38-0.54,0.77-1.08,1.15-1.63C389.17,643.71,388.78,644.24,388.4,644.79z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000070082357377822312370000007217438753033956995_",
    cx: 247.684,
    cy: 614.3618,
    r: 195.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070082357377822312370000007217438753033956995_)"
    },
    d: "M379.49,656.46 c-1.49,1.79-3.01,3.56-4.58,5.29C376.47,660.01,377.99,658.25,379.49,656.46z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000181053801693593054660000002940953301583905417_",
    cx: 247.6876,
    cy: 614.3611,
    r: 195.2172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181053801693593054660000002940953301583905417_)"
    },
    d: "M385.42,648.93 c1.02-1.36,2.01-2.75,2.98-4.14C387.42,646.18,386.43,647.56,385.42,648.93z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150089558894664568310000001890064117473534341_",
    cx: 247.6766,
    cy: 614.3657,
    r: 195.2304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150089558894664568310000001890064117473534341_)"
    },
    d: "M383.93,650.89 c0.5-0.65,1-1.31,1.49-1.97C384.93,649.59,384.43,650.24,383.93,650.89z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013905233882697855050000012826700348866523282_",
    cx: 247.6754,
    cy: 614.3612,
    r: 195.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013905233882697855050000012826700348866523282_)"
    },
    d: "M408.26,607.27 c0.49-1.28,0.96-2.57,1.42-3.86C409.22,604.7,408.74,605.99,408.26,607.27z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000029033532847443438620000016566088136115184818_",
    cx: 247.6833,
    cy: 614.3607,
    r: 195.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029033532847443438620000016566088136115184818_)"
    },
    d: "M415.21,584.16 c0.3-1.33,0.6-2.67,0.87-4.01C415.8,581.49,415.51,582.82,415.21,584.16z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165222972330785976740000004813923981568534689_",
    cx: 247.6961,
    cy: 614.3617,
    r: 195.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165222972330785976740000004813923981568534689_)"
    },
    d: "M412.84,593.54 c0.6-2.12,1.17-4.25,1.69-6.4C414.01,589.3,413.44,591.43,412.84,593.54z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000018217526107542692270000005481837872991057576_",
    cx: 247.6357,
    cy: 614.3617,
    r: 195.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018217526107542692270000005481837872991057576_)"
    },
    d: "M414.53,587.15 c0.24-0.99,0.45-1.99,0.68-2.99C414.98,585.15,414.77,586.16,414.53,587.15z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072976370095916899570000008887205590350823045_",
    cx: 247.7399,
    cy: 614.3612,
    r: 195.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072976370095916899570000008887205590350823045_)"
    },
    d: "M416.07,580.14 c0.22-1.12,0.43-2.25,0.63-3.38C416.5,577.89,416.3,579.02,416.07,580.14z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096781528649312227030000016218949996704842893_",
    cx: 247.6885,
    cy: 614.3593,
    r: 195.2174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096781528649312227030000016218949996704842893_)"
    },
    d: "M417.16,574.07 c-0.15,0.9-0.29,1.8-0.45,2.7c0.1-0.57,0.22-1.13,0.32-1.69C417.06,574.81,417.11,574.46,417.16,574.07z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000118364127210771056180000007803599143274513540_",
    cx: 247.6837,
    cy: 614.3611,
    r: 195.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118364127210771056180000007803599143274513540_)"
    },
    d: "M344.67,404.13 c-12.59-7.92-25.72-13.28-41.42-15.81c-7.58-1.23-15.95-1.78-24.51-0.92c15.47,3.98,62.66,17.17,78.29,45.42 c-10.79,2.22-42.78,8.72-75.87,26.47c-33.98,18.23-33.98,15.98-33.98,15.98s0,2.25-33.97-15.98 c-33.09-17.75-66.2-24.56-76.26-26.52c15.63-28.25,63.21-41.39,78.68-45.36c-8.56-0.87-16.93-0.32-24.51,0.92 c-15.7,2.54-30.84,9.52-41.42,15.81c-47.1,28.03-74.78,83.08-74.78,142.03c0,13.09,1.47,25.84,4.24,38.1 c-0.68-3.04-1.29-6.1-1.81-9.19c-0.79-5.51-4.75-40.85,14.86-88.24c2.59-6.24,5.97-13.02,14.55-11.11 c7.94,1.76,104.8,38.66,110.68,42.48c5.88,3.82,7.94,11.46,7.94,29.4c0,17.93-2.35,68.79-1.18,92.3 c0.57,11.48,1.95,22.47,2.39,31.3c0.97,19.38-1.6,20.8-19.89,21.13c-20.44,0.37-56.11-4.51-85.05-28.22 c12.77,13.58,27.7,25.09,44.27,33.97c6.18,3.31,11.52,5.68,17.31,7.59c19.78,7.93,41.35,12.32,63.96,12.32 c22.61,0,44.18-4.4,63.96-12.32c5.79-1.91,11.13-4.27,17.31-7.58c16.57-8.88,31.5-20.4,44.27-33.97 c-28.94,23.71-64.61,28.59-85.05,28.22c-18.29-0.33-20.86-1.75-19.89-21.13c0.44-8.84,1.82-19.83,2.39-31.3 c1.18-23.52-1.17-74.37-1.17-92.3c0-17.93,2.06-25.58,7.94-29.4c5.88-3.82,102.74-40.71,110.68-42.48 c8.58-1.91,11.96,4.87,14.55,11.11c18.68,45.14,15.97,79.33,14.99,87.24c1.48-9.09,2.3-18.4,2.3-27.9 C419.45,487.22,391.08,433.3,344.67,404.13z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000163054795847037226230000001683785685779083152_",
    cx: 247.6818,
    cy: 614.3615,
    r: 195.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163054795847037226230000001683785685779083152_)"
    },
    d: "M407.18,610.07 c0.37-0.93,0.72-1.86,1.07-2.8C407.9,608.2,407.55,609.14,407.18,610.07z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000124132141852048394750000005908328833988151695_",
    cx: 247.6781,
    cy: 614.3611,
    r: 195.2297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124132141852048394750000005908328833988151695_)"
    },
    d: "M403.89,617.74 c0.39-0.86,0.78-1.72,1.16-2.58C404.66,616.03,404.28,616.89,403.89,617.74z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000103224307116196433160000002866908351193187468_",
    cx: 247.6932,
    cy: 614.3611,
    r: 195.2111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103224307116196433160000002866908351193187468_)"
    },
    d: "M405.04,615.16 c0.74-1.69,1.46-3.38,2.14-5.1C406.5,611.78,405.78,613.48,405.04,615.16z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000135657712726924307830000008209644048217968802_",
    cx: 247.6778,
    cy: 614.3614,
    r: 195.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135657712726924307830000008209644048217968802_)"
    },
    d: "M410.71,600.39 c0.44-1.32,0.85-2.64,1.25-3.97C411.56,597.75,411.15,599.08,410.71,600.39z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000036220209119056398390000008626104059048798100_",
    cx: 247.7031,
    cy: 614.3607,
    r: 195.1993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036220209119056398390000008626104059048798100_)"
    },
    d: "M409.68,603.41 c0.35-1,0.7-2.01,1.04-3.02C410.38,601.4,410.03,602.41,409.68,603.41z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000074415251456299940580000014216626562103063995_",
    cx: 247.6649,
    cy: 614.3602,
    r: 195.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074415251456299940580000014216626562103063995_)"
    },
    d: "M411.96,596.42 c0.29-0.96,0.6-1.91,0.87-2.87C412.56,594.51,412.26,595.46,411.96,596.42z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047771499753017664100000015296999692833023116_",
    cx: 245.0361,
    cy: 610.6174,
    r: 161.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047771499753017664100000015296999692833023116_)"
    },
    d: "M372.87,663.95 c0.62-0.66,1.24-1.33,1.86-2.01C374.11,662.62,373.49,663.29,372.87,663.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092423826820423179730000011058816727398278069_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.6169,
    y1: 655.5682,
    x2: 382.3968,
    y2: 655.5682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#433717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#946F29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000092423826820423179730000011058816727398278069_)"
    },
    d: " M267.79,671.19c-0.09,1.86-0.15,3.55-0.17,5.1c4.12,4.08,8.48,4.84,15.5,5.14c27.56,1.14,53.98-4.37,74.76-21.24 c9.37-7.6,16.93-18.02,24.51-30.63C373.78,642.87,340.57,684.35,267.79,671.19z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M497.9,554.6c-12.89,0-24.96-3.43-30.72-6.61l-0.5-0.28l5.29-21.51l0.84,0.43 c8.06,4.13,17.98,6.59,26.52,6.59c10.33,0,16.26-3.95,16.26-10.85c0-6.09-4.41-9.72-17.46-14.39c-19.84-6.91-29.9-17.79-29.9-32.34 c0-19.75,16.59-33.02,41.28-33.02c10.28,0,19.58,1.84,27.65,5.47l0.59,0.26l-5.82,21.04l-0.81-0.39 c-6.9-3.33-14.34-5.01-22.09-5.01c-9.01,0-14.82,3.76-14.82,9.58c0,6.38,5.9,9.29,19.38,14.4c19.57,7.24,28.3,17.31,28.3,32.65 C541.89,541.27,524.62,554.6,497.9,554.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M472.47,527.31c6.52,3.34,16.53,6.68,26.86,6.68c11.13,0,17.01-4.61,17.01-11.6c0-6.68-5.09-10.49-17.96-15.1 c-17.8-6.2-29.4-16.05-29.4-31.63c0-18.28,15.26-32.27,40.53-32.27c12.08,0,20.98,2.54,27.34,5.4l-5.4,19.55 c-4.29-2.07-11.92-5.09-22.41-5.09c-10.49,0-15.58,4.77-15.58,10.33c0,6.83,6.04,9.86,19.87,15.1 c18.91,6.99,27.82,16.85,27.82,31.95c0,17.96-13.83,33.22-43.23,33.22c-12.24,0-24.32-3.18-30.36-6.52L472.47,527.31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M602.06,553.01v-43.51c0-10.89-3.97-16.41-11.8-16.41c-7.56,0-10.63,6.09-11.38,7.96 c-0.49,1.23-0.74,2.95-0.74,5.12v46.84h-25.66V438.66h25.66v43.37c2.33-2.7,5.2-4.96,8.75-6.88c3.62-1.98,8.33-3.11,12.91-3.11 c17.49,0,27.93,13,27.93,34.77v46.21H602.06z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M553.22,439.41h24.16v44.34h0.32c2.54-3.34,5.72-5.88,9.54-7.94c3.5-1.91,8.1-3.02,12.55-3.02 c15.42,0,27.18,10.65,27.18,34.01v45.46h-24.16v-42.75c0-10.17-3.5-17.16-12.55-17.16c-6.36,0-10.33,4.13-12.08,8.42 c-0.64,1.59-0.8,3.66-0.8,5.4v46.09h-24.16V439.41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M642.75,553.01v-79.22h25.66v79.22H642.75z M655.42,465.76c-3.91,0-7.41-1.38-9.86-3.89 c-2.3-2.35-3.52-5.53-3.44-8.95c-0.08-3.5,1.14-6.74,3.43-9.09c2.45-2.5,6.01-3.88,10.03-3.88c7.85,0,13.45,5.34,13.63,12.97 C669.2,460.36,663.41,465.76,655.42,465.76z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M668.45,452.93c0,6.67-5.09,12.08-13.04,12.08c-7.63,0-12.71-5.4-12.55-12.08c-0.16-7,4.93-12.24,12.72-12.24 C663.37,440.69,668.29,445.93,668.45,452.93z M643.5,552.26v-77.72h24.16v77.72H643.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M686.14,553.01v-59.92h-10.17v-19.3h10.17v-2.27c0-11.08,3.68-20.79,10.1-26.62 c7.6-7.2,17.89-7.98,21.96-7.98c5,0,9.27,0.53,13.08,1.62l0.57,0.16l-1.03,20.15l-0.92-0.28c-2.36-0.73-4.84-1.08-7.57-1.08 c-9.5,0-10.53,9.14-10.53,13.08v3.22h15.57v19.3h-15.42v59.92H686.14z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M686.89,552.26v-59.92h-10.17v-17.8h10.17v-3.02c0-9.38,2.86-19.71,9.85-26.07 c6.04-5.72,14.46-7.79,21.46-7.79c5.4,0,9.54,0.63,12.87,1.59l-0.95,18.6c-2.07-0.64-4.61-1.11-7.79-1.11 c-7.94,0-11.28,6.2-11.28,13.83v3.97h15.57v17.8h-15.42v59.92H686.89z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M766.04,554.6c-7.64,0-14.44-2.52-18.66-6.91c-4.63-4.8-6.88-12.51-6.88-23.57v-31.04h-10.33v-19.3h10.33 v-16.69l25.18-5.75v22.44h17.33v19.3h-17.33v27.38c0,9.54,2.3,12.92,8.79,12.92c2.42,0,4.71-0.2,7.02-0.62l0.88-0.16l0.17,19.68 l-0.48,0.19C778.68,553.83,772.85,554.6,766.04,554.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M764.93,452.29v22.25h17.33v17.8h-17.33v28.13c0,9.38,2.22,13.67,9.54,13.67c3.02,0,5.41-0.32,7.16-0.64 l0.16,18.28c-3.18,1.27-8.9,2.06-15.73,2.06c-7.79,0-14.3-2.7-18.12-6.67c-4.45-4.61-6.67-12.08-6.67-23.05v-31.79h-10.33v-17.8 h10.33v-16.85L764.93,452.29z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M489.68,659.81c-7.69,0-14.66-0.4-20.72-1.2l-0.65-0.09v-80.21l0.63-0.1c6.73-1.08,15.49-1.68,24.68-1.68 c15.05,0,25.34,2.69,33.35,8.73c9.08,6.75,13.89,17.43,13.89,30.88c0,17.85-7.41,27.86-13.62,33.12 C518.81,656.27,506.17,659.81,489.68,659.81z M488.05,643.9c1.49,0.23,3.64,0.23,5.57,0.23h0.32c8.13,0,14.53-2.25,19-6.7 c4.72-4.69,7.11-11.64,7.11-20.68c0.06-7.86-2.07-14.01-6.32-18.29c-4.2-4.23-10.49-6.47-18.2-6.47c-3.64,0-6.02,0.29-7.47,0.57 V643.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M469.06,578.96c6.68-1.07,15.38-1.67,24.56-1.67c15.26,0,25.15,2.74,32.9,8.58 c8.34,6.2,13.59,16.09,13.59,30.28c0,15.38-5.6,25.99-13.35,32.54c-8.46,7.03-21.34,10.37-37.07,10.37 c-9.42,0-16.09-0.6-20.62-1.19V578.96z M487.29,644.52c1.55,0.36,4.05,0.36,6.32,0.36c16.45,0.12,27.18-8.94,27.18-28.13 c0.12-16.69-9.66-25.51-25.27-25.51c-4.05,0-6.68,0.36-8.23,0.72V644.52z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M575.63,660.17c-19.95,0-31.86-11.38-31.86-30.43c0-15.35,9.45-31.86,30.2-31.86 c19.71,0,26.74,15.41,26.74,29.84c0,2.91-0.32,5.67-0.61,7.29l-0.11,0.62h-37.34c1.08,7.05,8.68,9.59,15.61,9.59 c5.85,0,10.74-0.72,15.86-2.35l0.8-0.25l2.66,13.71l-0.58,0.23C591.07,658.92,583.68,660.17,575.63,660.17z M582.37,621.72 c-0.15-2.83-1.33-10.3-9.48-10.3c-6.93,0-9.7,6.13-10.35,10.3H582.37z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M561.8,634.86c0.59,7.51,7.99,11.09,16.45,11.09c6.2,0,11.21-0.84,16.09-2.39l2.39,12.28 c-5.96,2.39-13.23,3.58-21.1,3.58c-19.79,0-31.11-11.44-31.11-29.68c0-14.78,9.18-31.11,29.45-31.11 c18.83,0,25.98,14.66,25.98,29.09c0,3.1-0.36,5.84-0.6,7.15H561.8z M583.14,622.47c0-4.41-1.91-11.8-10.25-11.8 c-7.63,0-10.73,6.91-11.2,11.8H583.14z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 606.47,
    y: 572.84,
    className: "st35",
    width: 19.62,
    height: 86.13
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M607.22,573.59h18.12v84.63h-18.12V573.59z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M664.2,660.17c-19.95,0-31.86-11.38-31.86-30.43c0-15.35,9.45-31.86,30.19-31.86 c19.71,0,26.74,15.41,26.74,29.84c0,2.91-0.31,5.67-0.61,7.29l-0.11,0.62h-37.33c1.08,7.05,8.67,9.59,15.61,9.59 c5.85,0,10.74-0.72,15.86-2.35l0.8-0.25l2.66,13.71l-0.58,0.23C679.64,658.92,672.25,660.17,664.2,660.17z M670.94,621.72 c-0.15-2.83-1.33-10.3-9.48-10.3c-6.93,0-9.7,6.13-10.35,10.3H670.94z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M650.37,634.86c0.6,7.51,7.99,11.09,16.45,11.09c6.2,0,11.21-0.84,16.09-2.39l2.39,12.28 c-5.96,2.39-13.23,3.58-21.1,3.58c-19.79,0-31.11-11.44-31.11-29.68c0-14.78,9.18-31.11,29.44-31.11 c18.84,0,25.99,14.66,25.99,29.09c0,3.1-0.36,5.84-0.59,7.15H650.37z M671.71,622.47c0-4.41-1.91-11.8-10.25-11.8 c-7.63,0-10.73,6.91-11.2,11.8H671.71z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M716.89,660.17c-5.78,0-10.93-1.91-14.13-5.24c-3.51-3.64-5.22-9.46-5.22-17.81v-23.09h-7.75v-14.85h7.75 V586.7l19.27-4.4v16.88h12.99v14.85h-12.99v20.35c0,7.02,1.67,9.5,6.4,9.5c1.8,0,3.51-0.15,5.23-0.47l0.88-0.16l0.13,15.11 l-0.48,0.19C726.42,659.59,722.02,660.17,716.89,660.17z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M716.06,583.25v16.69h12.99v13.35h-12.99v21.1c0,7.03,1.66,10.25,7.15,10.25c2.27,0,4.05-0.24,5.37-0.48 l0.12,13.71c-2.39,0.95-6.67,1.55-11.8,1.55c-5.84,0-10.72-2.03-13.59-5.01c-3.34-3.46-5.01-9.06-5.01-17.29v-23.84h-7.75v-13.35 h7.75V587.3L716.06,583.25z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M763.14,660.17c-19.95,0-31.86-11.38-31.86-30.43c0-15.35,9.45-31.86,30.2-31.86 c19.71,0,26.73,15.41,26.73,29.84c0,2.91-0.31,5.67-0.61,7.29l-0.11,0.62h-37.33c1.08,7.05,8.67,9.59,15.6,9.59 c5.85,0,10.74-0.72,15.86-2.35l0.8-0.25l2.66,13.71l-0.58,0.23C778.58,658.92,771.19,660.17,763.14,660.17z M769.88,621.72 c-0.15-2.83-1.33-10.3-9.48-10.3c-6.93,0-9.69,6.13-10.35,10.3H769.88z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M749.32,634.86c0.59,7.51,7.98,11.09,16.45,11.09c6.2,0,11.21-0.84,16.09-2.39l2.39,12.28 c-5.96,2.39-13.23,3.58-21.1,3.58c-19.79,0-31.11-11.44-31.11-29.68c0-14.78,9.18-31.11,29.45-31.11 c18.83,0,25.98,14.66,25.98,29.09c0,3.1-0.36,5.84-0.59,7.15H749.32z M770.65,622.47c0-4.41-1.91-11.8-10.25-11.8 c-7.63,0-10.73,6.91-11.2,11.8H770.65z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M793.17,648.56c0-5.28,3.62-9.09,8.79-9.09s8.69,3.71,8.69,9.09c0,5.18-3.51,8.98-8.79,8.98 C796.78,657.55,793.17,653.74,793.17,648.56z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M867.84,658.98l-17.38-31.38c-2.9-5.22-8.21-15.13-12.77-25.6c0.39,9.84,0.58,20.36,0.58,32.03v24.95h-18.19 v-81.85h22.41l16.9,29.83c4.13,7.32,8.28,15.86,11.66,23.94c-0.79-8.46-1.14-17.77-1.14-29.53v-24.24h18.19v81.85H867.84z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M820.84,658.23v-80.35h21.22l16.69,29.45c4.77,8.46,9.54,18.48,13.12,27.54h0.36 c-1.2-10.61-1.55-21.46-1.55-33.5v-23.49h16.69v80.35h-19.08l-17.16-30.99c-4.77-8.58-10.02-18.96-13.95-28.37l-0.36,0.12 c0.48,10.61,0.71,21.94,0.71,35.05v24.2H820.84z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M926.34,660.17c-19.95,0-31.86-11.38-31.86-30.43c0-15.35,9.45-31.86,30.2-31.86 c19.71,0,26.73,15.41,26.73,29.84c0,2.91-0.31,5.67-0.61,7.29l-0.11,0.62h-37.33c1.08,7.05,8.67,9.59,15.61,9.59 c5.85,0,10.74-0.72,15.86-2.35l0.8-0.25l2.66,13.71l-0.58,0.23C941.78,658.92,934.39,660.17,926.34,660.17z M933.08,621.72 c-0.15-2.83-1.33-10.3-9.48-10.3c-6.93,0-9.69,6.13-10.35,10.3H933.08z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M912.52,634.86c0.6,7.51,7.98,11.09,16.45,11.09c6.2,0,11.21-0.84,16.09-2.39l2.39,12.28 c-5.96,2.39-13.23,3.58-21.1,3.58c-19.79,0-31.11-11.44-31.11-29.68c0-14.78,9.18-31.11,29.45-31.11 c18.83,0,25.98,14.66,25.98,29.09c0,3.1-0.36,5.84-0.59,7.15H912.52z M933.85,622.47c0-4.41-1.91-11.8-10.26-11.8 c-7.63,0-10.73,6.91-11.2,11.8H933.85z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M979.03,660.17c-5.78,0-10.93-1.91-14.13-5.24c-3.51-3.64-5.22-9.46-5.22-17.81v-23.09h-7.75v-14.85h7.75 V586.7l19.26-4.4v16.88h12.99v14.85h-12.99v20.35c0,7.02,1.68,9.5,6.4,9.5c1.8,0,3.51-0.15,5.23-0.47l0.88-0.16l0.13,15.11 l-0.48,0.19C988.56,659.59,984.16,660.17,979.03,660.17z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M978.2,583.25v16.69h12.99v13.35H978.2v21.1c0,7.03,1.67,10.25,7.15,10.25c2.27,0,4.05-0.24,5.37-0.48 l0.12,13.71c-2.39,0.95-6.67,1.55-11.8,1.55c-5.84,0-10.73-2.03-13.59-5.01c-3.34-3.46-5.01-9.06-5.01-17.29v-23.84h-7.75v-13.35 h7.75V587.3L978.2,583.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049903797994860920470000007204702927295820214_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.3892,
    y1: 367.148,
    x2: 369.0068,
    y2: 440.6093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAE922"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000049903797994860920470000007204702927295820214_)"
    },
    d: " M352.8,433.7c5.28-1.14,10.62-2.12,15.99-2.9c-0.04-0.11-0.04-0.2-0.1-0.31c-1.32-2.79-8.68-13.11-28.57-26.2 c-22.07-14.53-52.8-17.26-53.42-17.3c-1.75-0.13-8.87-0.46-12.36,0C323.79,395.85,345.85,423.51,352.8,433.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182524178910928473160000007137121914174325406_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.6716,
    y1: 388.9893,
    x2: 195.7164,
    y2: 425.5271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BF15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAE922"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000182524178910928473160000007137121914174325406_)"
    },
    d: " M141.69,433.75c6.91-10.14,28.96-37.88,78.5-46.76c-3.49-0.46-10.6-0.13-12.36,0c-0.62,0.04-31.35,2.77-53.42,17.3 c-19.89,13.09-27.25,23.41-28.57,26.2c-0.06,0.13-0.06,0.23-0.11,0.35C131.09,431.62,136.42,432.6,141.69,433.75z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M418.39,524.19c-1.42-9.96-6.26-26.41-12.08-38.88c-2.41-5.16-6.72-16.24-19.08-13.47 c-2.62,0.58-17.95,6.12-36.49,13.05l-0.15-0.01l-0.85,0.32c-17.73,6.66-69.47,26.4-74.5,29.67c-0.17,0.11-0.33,0.22-0.49,0.33 c-7.1,4.97-8.97,14.35-9.22,28.56l-1.43,133.16l-0.01,1.01l0.01,0.01c0.06,6.33,1,10.5,3.81,13.51c3.96,4.24,10.55,4.67,20.16,4.85 c0.57,0.01,1.22,0.02,1.92,0.02c11.02,0,37.68-1.66,64.33-15.25c39.87-31.55,65.48-80.33,65.48-135.12 C419.81,538.57,419.29,531.32,418.39,524.19z M381.79,623.58c-7.17,12.3-15.28,24.87-25.94,33.52 c-18.17,14.74-42.42,21.61-72.1,20.35c-3.93-0.16-6.66-0.47-8.9-1.36c0,0-2.41-0.6-2.71-3.79l1.31-122.56 c-0.01-0.76-0.01-1.49-0.01-2.16c0-0.06,0-0.11,0-0.17l0.04-3.58c0.31-15.36,2.58-20.03,6.09-22.31c0,0,0,0,0,0h0l74.27-28.79 c5.35-2.09,20.72-7.63,27.55-8.28c0.07-0.01,0.14-0.01,0.21-0.01c2.77,0,6.32,5.07,10.56,15.08l0.49,1.15 C400.42,518.74,414.88,566.86,381.79,623.58z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M230.74,676.92l0.01,0l-1.43-133.16h-0.01c-0.25-14.21-2.12-23.59-9.22-28.56c-0.16-0.11-0.33-0.22-0.49-0.33 c-5.03-3.27-56.77-23.01-74.5-29.67l-0.85-0.32l-0.15,0.01c-18.54-6.94-33.87-12.47-36.49-13.05 c-12.36-2.77-16.67,8.31-19.08,13.47c-5.82,12.47-10.66,28.92-12.08,38.88c-0.9,7.13-1.42,14.38-1.42,21.75 c0,54.79,25.61,103.57,65.48,135.12c26.64,13.59,53.3,15.25,64.33,15.25c0.71,0,1.35-0.01,1.92-0.02c9.6-0.17,16.2-0.61,20.16-4.85 c2.81-3.01,3.75-7.18,3.81-13.51l0.01-0.01L230.74,676.92L230.74,676.92z M211.1,677.46c-29.68,1.25-53.93-5.62-72.1-20.35 c-10.66-8.65-18.76-21.22-25.94-33.52c-33.08-56.73-18.63-104.85-10.87-122.9l0.49-1.15c4.24-10.01,7.79-15.08,10.56-15.08 c0.07,0,0.14,0.01,0.21,0.01c6.84,0.64,22.21,6.19,27.55,8.28l74.27,28.79h0c0,0,0,0,0,0c3.78,2.46,6.13,7.68,6.13,26.06 c0,0.67,0,1.4-0.01,2.16l1.3,121.63c-0.15,3.18-2.7,4.72-2.7,4.72C217.76,676.99,215.03,677.29,211.1,677.46z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdn);
export default __webpack_public_path__ + "static/media/sdn.f2f9b591716978e7f9e276282133d0ba.svg";
export { ForwardRef as ReactComponent };